import React from 'react';
import { connect } from 'react-redux';
import { ButtonGroup, Container, Row, Col, Nav, NavItem, NavLink, TabContent, TabPane, Modal, ModalHeader, ModalBody , ModalFooter } from 'reactstrap';
import ScribeNotification from './ScribeNotification';
import CONVERSIONS from '../constants/conversions';
import { Fetch } from '../api';
import ButtonAction from './ButtonAction';
import ButtonDelete from './ButtonDelete';
import ChecksPanel from './ChecksPanel';
import ConversionList from './ConversionList';
import CreatorList from './CreatorList';
import ConformanceList from './ConformanceList';
import FileList from './FileList';
import ImportModal from './ImportModal';
import IsbnList from './IsbnList';
import LoadingModal from './LoadingModal';
import LogList from './LogList';
import ProjectMetadata from './ProjectMetadata';
import ProjectAccessibilityMetadata from './ProjectAccessibilityMetadata';
import ProjectMetadataExtended from './ProjectMetadataExtended';
import StatisticsPanel from './StatisticsPanel';
import UserAccess from './UserAccess';
import moment from 'moment';
import { groupForFile, isConvertable } from '../helpers/FileHelpers';
import { olderThanMinutes } from '../helpers/GenericHelpers';
import * as actionCreators from '../action_creators';
import { toJS } from '../helpers/toJS';

export class Project extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      statisticsPane: false,
      statisticsName: '',
      checksPane: false,
      checksName: '',
      activeTab: this.props.defaultTab || 1,
      activeAlertsTab: 1,
      checkNewWarning: true,
    };
  }

  componentDidMount() {
    this.props.setSubjectData();
    if (this.props.loading) {
      this.props.pollStatus(this.props.id);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.error) {
      this.props.clearError();
    }
    if (prevProps.loading == true && this.props.loading == false){
      this.setState({ checkNewWarning: true})
    }
  }

  loading() {
    return this.props.loading || false;
  }

  loadingMessage() {
    return this.props.loadingMessage || '';
  }

  hasError() {
    return !!this.props.error;
  }

  toggleStatisticsPane = () => {
    this.setState({ statisticsPane: !this.state.statisticsPane });
  }

  toggleChecksPane = () => {
    this.setState({ checksPane: !this.state.checksPane });
  }

  toggleWarning = () => {
    this.setState({ checkNewWarning: !this.state.checkNewWarning });
  }

  selectTab = (tabID) => {
    const currentScroll = document.body.parentNode.scrollTop;
    this.setState({ activeTab: tabID }, () => {this.scrollTabToTop(currentScroll)});
  }

  scrollTabToTop(currentScroll){
    const element = document.getElementById("project-header");
    if (currentScroll > element.offsetHeight){
      document.body.parentNode.scrollTop = element.offsetHeight;
    }
  }


  selectAlertsTab = (tabID) => {
    this.setState({ activeAlertsTab: tabID });
  }

  getFiles() {
    return this.props.files.filter((f) => f.type !== 'sample');
  }

  updateStatistics = (id, name, stats = null) => {
    if (stats) {
      this.props.setState({ statistics: stats });
    } else {
      this.props.getStatistics(id);
    }
    this.setState({
      checksPane: false,
      statisticsName: name,
      statisticsPane: true,
    });
  }

  updateGroupStatistics = (fileGroup) => {
    this.props.getGroupStatistics(this.props.id, fileGroup);
    this.setState({
      checksPane: false,
      statisticsName: `${fileGroup} files`,
      statisticsPane: true,
    });
  }

  updateChecks = (id, name, checks = null) => {
    if (checks) {
      this.props.setState({ checks });
    } else {
      this.props.getChecks(id);
    }
    this.setState({
      statisticsPane: false,
      checksName: name,
      checksPane: true,
    });
  }

  latestAssetType = () => {
    let type;
    let compTime = moment(0);
    this.getFiles().map((file) => {
      const fileType = file.type;
      const fileMod = file.created_at;
      if (!!fileMod && !!fileType) {
        const date = moment(fileMod);
        if (date.isAfter(compTime)) {
          compTime = date;
          type = fileType;
        }
      }
    });
    return type;
  }

  latestConvertableAssetType = () => {
    let type;
    let compTime = moment(0);
    this.getFiles().map((file) => {
      const fileType = file.type;
      const fileMod = file.updated_at;
      if (!!fileMod && !!fileType && isConvertable(fileType)) {
        const date = moment(fileMod);
        if (date.isAfter(compTime)) {
          compTime = date;
          type = fileType;
        }
      }
    });
    return type;
  }

  availableFileTypes = () => this.getFiles().map(file => file.type)

  imageFileOptions = () => {
    const opts = [];
    this.getFiles().map((file) => {
      const group = groupForFile(file);
      if (group === 'image') {
        const val = file.id ? file.id.toString() : null;
        opts.push({ value: val, label: file.name });
      }
    });
    return opts;
  }

  getUsers() {
    return this.props.users || [];
  }

  getCover() {
    return this.props.cover ? this.props.cover.toString() : null;
  }

  getUser() {
    return this.props.user ? this.props.user.toString() : null;
  }

  userOptions = () => {
    const options = [];
    this.getUsers().map((user) => {
      options.push({ value: user.id.toString(), label: user.name });
    });
    return options;
  }

  getConverterLogs() {
    return this.props.converter_logs || [];
  }

  getActivities() {
    return this.props.activities || [];
  }

  getConversions() {
    return this.props.activities.filter(activity => activity.heading === 'conversion') || [];
  }

  // this is for adding the project ID so that we don't have to pass it down
  // with every callback
  wrapper = callback => function (...args) {
    callback(this.props.id, ...args);
  }.bind(this)

  // IF conversion alert exists and is less than a minute old
  //  AND IF it is an error
  //    RETURN 2 (error)
  //  ELSE IF it takes place between the most recent two logged activities
  //    (then we know it's a conversion warning)
  //    RETURN 1 (warning)
  //  ELSE
  //    RETURN 0 (success)
  recentConversionAlert = () => {
    const logs = this.getConverterLogs();
    if (
      logs.length > 0 &&
      !!logs[0] &&
      olderThanMinutes(logs[0].updated_at, 1)
    ) {
      if (logs[0].heading === 'error') {
        return 2;
      }
      const alertTime = moment(logs[0].updated_at);
      const activities = this.getActivities();
      if (activities.length > 0) {
        const activityOne = activities[0].updated_at;
        const activityTwo = activities[1].updated_at;
        if (
          (alertTime.isBefore(activityOne) || alertTime.isSame(activityOne)) &&
          (alertTime.isAfter(activityTwo) || alertTime.isSame(activityTwo))
        ) {
          return 1;
        }
      }
    }
    return 0;
  }

  alertsTab = () => {
    const level = this.recentConversionAlert();
    if (level === 0) {
      return 'Alerts and Updates';
    } else if (level === 1) {
      return (<span>Alerts and Updates{' '}
        <span className="badge bg-warning">
          <i className="fa fa-star" aria-hidden="true" />
        </span>
      </span>);
    } else if (level === 2) {
      return (<span>Alerts and Updates{' '}
        <span className="badge bg-danger">
          <i className="fa fa-star" aria-hidden="true" />
        </span>
      </span>);
    }
  }

  conversionWarnings(){
    if (!this.props.activities) {return null;}
    const activities = this.getConversions();
    if (activities.length == 0) {return null;}
    const activityOne = activities[0].updated_at;
    const activityTwo = activities[1] ? activities[1].updated_at : moment().subtract(1, 'days'); //if it's the first conversion, set the start of the range to yesterday
    const recentLogs = this.getConverterLogs().filter(log => (
      (log.heading === 'warning' && (moment(log.updated_at).isBefore(activityOne) || moment(log.updated_at).isSame(activityOne)) && (moment(log.updated_at).isAfter(activityTwo) || moment(log.updated_at).isSame(activityTwo))) ||
      (olderThanMinutes(log.updated_at, 1) && log.heading === 'error')
      ));

    if (recentLogs.length > 0 && olderThanMinutes(recentLogs[0].updated_at, 1)){
      return(
        <Modal
          isOpen={this.state.checkNewWarning}
          toggle={this.toggleWarning}
          size="l"
        >
          <ModalHeader>Conversion Alerts</ModalHeader>
          <ModalBody>
            <p>New alerts were added to the project during a recent conversion. See all prior conversion alerts under the alerts tab.</p>
            <LogList heading={false} logs={recentLogs} color />
          </ModalBody>
          <ModalFooter>
            <ButtonAction
              action={this.toggleWarning}
              color="success"
            >
              OK
            </ButtonAction>
          </ModalFooter>
        </Modal>
      );
    }
  }

  performConversion = (conv) => {
    const convType = CONVERSIONS.find(c => c.slug === conv);
    const error = this.getFiles().find(f => f.type === convType.input && f.error_level === 'error');
    if (error) {
      this.props.setState({ error: 'Your input files contain one or more critical errors.' });
    } else {
      this.props.performConversion(this.props.id, conv);
    }
  }

  render() {
    const latest = this.latestAssetType();
    return (<div>
      <ScribeNotification
        error
        isActive={this.hasError()}
        message={this.props.error || ''}
        action={'close'}
        onClick={this.props.clearError}
        activeBarStyle={{ zIndex: 10000 }}
      />
      {this.conversionWarnings()}
      <LoadingModal
        modalOpen={this.loading()}
        header={this.loadingMessage()}
        closeModal={() => true}
      />
      <ImportModal
        importData={this.props.importData}
        code={this.props.code}
        title={this.props.title}
        projectUpdate={this.wrapper(this.props.updateProject)}
        isbns={this.props.isbns}
        createIsbn={this.wrapper(this.props.createIsbn)}
        updateIsbn={this.wrapper(this.props.updateIsbn)}
      />
      <div className="hero hub project-header" id="project-header">
        <Container fluid>
          <Row>
            <Col md={7}>
              <h1>{this.props.code}</h1>
            </Col>
            <Col md={5}>
              <ButtonGroup className="project-actions hero-btn-group">
                <a
                  className="btn btn-secondary"
                  href="/wfdw/projects"
                >
                  <i className="fa fa-cog" />
                  {' '}
                  <span className="hidden-sm-down">
                    Project List
                  </span>
                </a>
                <a
                  className="btn btn-secondary"
                  title={`Download ${this.props.code}`}
                  data-turbolinks={false}
                  href={`/get/archive/${this.props.id}`}
                >
                  <i className="fa fa-download" />
                  {' '}
                  <span className="hidden-sm-down">
                    Download
                  </span>
                </a>
                <ButtonDelete
                  key={`${this.props.code}-del`}
                  action={() => Fetch.delete(`/wfdw/projects/${this.props.id}`, {}, true)}
                  title={`Delete ${this.props.code}`}
                />
              </ButtonGroup>
            </Col>
          </Row>
          <ConversionList
            key={latest}
            target={this.latestConvertableAssetType()}
            access={this.props.access}
            available={this.availableFileTypes()}
            settings={this.props.settings}
            updateSettings={this.wrapper(this.props.updateSettings)}
            performConversion={this.performConversion}
          />
        </Container>
      </div>
      <div className="project">
        <Nav tabs id="project-top-nav">
          <NavItem>
            <NavLink
              role="tab"
              onClick={() => this.selectTab(1)}
              className={(this.state.activeTab == 1 ? 'active' : '')}
            >
              Files
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              role="tab"
              onClick={() => this.selectTab(2)}
              className={(this.state.activeTab == 2 ? 'active' : '')}
            >
              Project Information
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              role="tab"
              onClick={() => this.selectTab(3)}
              className={(this.state.activeTab == 3 ? 'active' : '')}
            >
              Accessibility
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              role="tab"
              onClick={() => this.selectTab(4)}
              className={(this.state.activeTab == 4 ? 'active' : '')}
            >
              {this.alertsTab()}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              role="tab"
              onClick={() => this.selectTab(5)}
              className={(this.state.activeTab == 5 ? 'active' : '')}
            >
              User Access
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              role="tab"
              href={`/wfdw/projects/${this.props.id}/uploader`}
            >
              <i className="fa fa-upload" aria-hidden /> Upload
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane
            tabId={1}
            className="project-tab"
          >
            <Container>
              <Row>
                <Col xs={12}>
                  <FileList
                    files={this.getFiles()}
                    org_assets={this.props.org_assets}
                    addOrgAssets={this.wrapper(this.props.addOrgAssets)}
                    projectId={this.props.id}
                    update={this.wrapper(this.props.updateFile)}
                    destroy={this.wrapper(this.props.destroyFile)}
                    target={latest}
                    projectId={this.props.id}
                    cover={this.getCover()}
                    projectUpdate={this.wrapper(this.props.updateProject)}
                    destroyGroup={this.wrapper(this.props.destroyFiles)}
                    updateGroup={this.wrapper(this.props.updateFiles)}
                    getStatistics={this.updateStatistics}
                    getGroupStatistics={this.updateGroupStatistics}
                    getChecks={this.updateChecks}
                  />
                </Col>
              </Row>
            </Container>
          </TabPane>
          <TabPane
            tabId={2}
            className="project-tab"
          >
            <Container className="project-metadata">
              <Row>
                <Col md="6">
                  <ProjectMetadata
                    code={this.props.code}
                    title={this.props.title}
                    publisher={this.props.publisher}
                    rights={this.props.rights}
                    cover={this.getCover()}
                    imageFiles={this.imageFileOptions()}
                    projectUpdate={this.wrapper(this.props.updateProject)}
                    subjects={this.props.subjects}
                    subjectsUpdate={this.props.updateSubjects}
                    subjectData={this.props.subjectData}
                  />
                  <IsbnList
                    isbns={this.props.isbns}
                    create={this.wrapper(this.props.createIsbn)}
                    update={this.wrapper(this.props.updateIsbn)}
                    destroy={this.wrapper(this.props.destroyIsbn)}
                  />
                </Col>
                <Col md="6">
                  <ProjectMetadataExtended
                    projectUpdate={this.wrapper(this.props.updateProject)}
                    subtitle={this.props.subtitle}
                    short_title={this.props.short_title}
                    collection_title={this.props.collection_title}
                    extended_title={this.props.extended_title}
                    edition_title={this.props.edition_title}
                    doi={this.props.doi}
                    languages={this.props.languages}
                    pubdate={this.props.pubdate}
                    description={this.props.description}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <CreatorList
                    creators={this.props.creators}
                    create={this.wrapper(this.props.createCreator)}
                    update={this.wrapper(this.props.updateCreator)}
                    destroy={this.wrapper(this.props.destroyCreator)}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <CreatorList
                    title='Contributors'
                    creators={this.props.contributors}
                    create={this.wrapper(this.props.createContributor)}
                    update={this.wrapper(this.props.updateContributor)}
                    destroy={this.wrapper(this.props.destroyContributor)}
                  />
                </Col>
              </Row>
            </Container>
          </TabPane>
          <TabPane
            tabId={3}
            className="project-tab"
          >
            <Container className="project-metadata">
              <Row>
                <Col md="12">
                  <ProjectAccessibilityMetadata
                    projectUpdate={this.wrapper(this.props.updateProject)}
                    accessibility_features={this.props.accessibility_features}
                    access_modes={this.props.access_modes}
                    access_modes_sufficient={this.props.access_modes_sufficient}
                    accessibility_summary={this.props.accessibility_summary}
                    pubdate={this.props.pubdate}
                    description={this.props.description}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <ConformanceList
                    title='Conformance'
                    conformances={this.props.conformances}
                    create={this.wrapper(this.props.createConformance)}
                    update={this.wrapper(this.props.updateConformance)}
                    destroy={this.wrapper(this.props.destroyConformance)}
                  />
                </Col>
              </Row>
            </Container>
          </TabPane>
          <TabPane
            tabId={4}
            className="project-tab"
          >
            <Container>
              <Row>
                <Col sm={2}>
                  <Nav vertical pills>
                    <NavItem className={this.state.activeAlertsTab == 1 ? 'active' : ''}>
                      <NavLink
                        onClick={() => this.selectAlertsTab(1)}
                        role="tab"
                      >
                        Conversion Alerts
                      </NavLink>
                    </NavItem>
                    <NavItem className={this.state.activeAlertsTab == 2 ? 'active' : ''}>
                      <NavLink
                        onClick={() => this.selectAlertsTab(2)}
                        role="tab"
                      >
                        Project Updates
                      </NavLink>
                    </NavItem>
                  </Nav>
                </Col>
                <Col sm={10}>
                  <TabContent activeTab={this.state.activeAlertsTab}>
                    <TabPane tabId={1}>
                      <LogList heading={false} logs={this.props.converter_logs} color />
                    </TabPane>
                    <TabPane tabId={2}>
                      <LogList heading={false} logs={this.props.activities} />
                    </TabPane>
                  </TabContent>
                </Col>
              </Row>
            </Container>
          </TabPane>
          <TabPane
            tabId={5}
            className="project-tab"
          >
            <Container>
              <Row>
                <Col xs={12}>
                  <UserAccess
                    user={this.getUser()}
                    users={this.userOptions()}
                    update={(id, attr, val) => this.props.updateProject(this.props.id, 'user', val)}
                    setUsers={this.props.setUsers}
                  />
                </Col>
              </Row>
            </Container>
          </TabPane>
        </TabContent>
      </div>
      {this.state.statisticsPane && this.props.statistics ?
        <StatisticsPanel
          filename={this.state.statisticsName}
          statistics={this.props.statistics}
          files={this.props.files}
          dismiss={this.toggleStatisticsPane}
        />
        : ''}
      {this.state.checksPane && this.props.checks ?
        <ChecksPanel
          filename={this.state.checksName}
          checks={this.props.checks}
          dismiss={this.toggleChecksPane}
        />
        : ''}
    </div>);
  }
}

Project.defaultProps = {
  files: []
}

// export so superset components (like Maker) can use this function
export function mapProjectStateToProps(state) {
  return {
    id: state.get('id'),
    code: state.get('code'),
    title: state.get('title'),
    publisher: state.get('publisher'),
    rights: state.get('rights'),
    subtitle: state.get('subtitle'),
    short_title: state.get('short_title'),
    collection_title: state.get('collection_title'),
    extended_title: state.get('extended_title'),
    edition_title: state.get('edition_title'),
    doi: state.get('doi'),
    languages: state.get('languages'),
    accessibility_features: state.get('accessibility_features'),
    access_modes: state.get('access_modes'),
    access_modes_sufficient: state.get('access_modes_sufficient'),
    accessibility_summary: state.get('accessibility_summary'),
    pubdate: state.get('pubdate'),
    description: state.get('description'),
    cover: state.get('cover'),
    subjects: state.get('subjects'),
    subjectData: state.get('subjectData'),
    creators: state.get('creators'),
    contributors: state.get('contributors'),
    conformances: state.get('conformances'),
    isbns: state.get('isbns'),
    settings: state.get('settings'),
    converter_logs: state.get('converter_logs'),
    activities: state.get('activities'),
    user: state.get('user'),
    access: state.get('access'),
    users: state.get('users'),
    files: state.get('files'),
    statistics: state.get('statistics'),
    checks: state.get('checks'),
    org_assets: state.get('org_assets'),
    loading: state.get('loading'),
    error: state.get('error'),
    loadingMessage: state.get('loadingMessage'),
    importData: state.get('import_data'),
  };
}

export const ProjectContainer = connect(
    mapProjectStateToProps,
    actionCreators,
)(toJS(Project));
